import { HttpMethod } from '@/types/HttpMethods';
import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { TaskResponse } from './types';

class Task {
  public static async execute(
    {
      url,
      method = HttpMethod.GET,
      body,
      headers,
    }: { url: string; method: HttpMethod; body?: any; headers?: any },
  ): Promise<TaskResponse> {
    try {
      let response: AxiosResponse<any> = {
        data: {},
        status: 0,
        statusText: '',
        headers: '',
        config: {},
      };

      switch (method) {
        case HttpMethod.GET:
          response = await axios.get(url, { headers });
          break;
        case HttpMethod.POST:
          response = await axios.post(url, body, { headers });
          break;
        case HttpMethod.PUT:
          response = await axios.put(url, body, { headers });
          break;
        case HttpMethod.DELETE:
          response = await axios.delete(url, { headers });
          break;
        default:
          throw new Error(`Unrecognized http method - ${method}`);
      }

      const { data, status } = response;

      return {
        result: [null, data],
        code: status,
      };
    } catch (error) {
      console.error(error);
      return {
        code: 500,
        result: [error.message || error, null],
      };
    }
  }
}

export default Task;
